<template>
  <div>
    <fieldset>
      <legend class="text-blue ts-font-robot">
        {{ $t('promotion.condition') }}
        <Tooltip placement="top">
          <Icon type="ios-information-circle-outline" size="17" />
          <div slot="content">
            <div class="ts-text-xs">
              {{ $t('promotion.condition') }}
            </div>
          </div>
        </Tooltip>
      </legend>
      <div class="overflow-auto ts-max-h-40">
        <div class="ts-flex ts-justify-end ts-pb-1 ts-mt--1">
          <Button type="info" size="small" @click="() => show_apply_all = true">{{
            $t('promotion.applyAll')
          }}</Button>
        </div>
        <ByProduct v-model="model" :validate="errors" />
      </div>
    </fieldset>
    <!-- show apply all pop-up -->
    <a-modal v-if="show_apply_all" v-model="show_apply_all" :title="$t('promotion.applyAll')" :maskClosable="false"
      :footer="null" width="900px">
      <ApplyAll v-model="model" @cancel="() => show_apply_all = false" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ByProduct from './incentive-by-amount/by-product.vue'
import ApplyAll from './incentive-by-amount/apply-all.vue'
export default {
  name: 'invcentiveByAmountCondition',
  props: ['value', 'validate'],
  components: {
    ByProduct,
    ApplyAll,
  },
  data() {
    return {
      errors: new Errors(),
      show_apply_all: false,
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('promotion/incentiveByAmount', ['formViewDatas']),
  },
  methods: {
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>